var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGooseFootprint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 359 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.174 84.502c18.897 10.443 37.526 1.07 59.842-9.483 24.712-11.697 39.501-17.577 51.356-6.82 10.899 9.885 6.982 24.328-5.079 50.75-10.391 22.651-17.141 47.095-5.49 63.933 10.534 15.208 27.302 18.89 40.686 20.638 16.193 2.135 27.056 4.038 32.024 13.194 5.357 9.842 1.23 30.805-41.411 55.34-42.642 24.534-119.732 57.261-168.717 71.721-55.66 16.432-102.028 30.378-130.227 3.602-27.847-26.442-13.613-74.625-2.225-111.959 14.174-46.439 46.983-129.906 76.303-182.699 28.469-51.31 47.687-55.07 59.175-50.698 13.805 5.212 12.254 25.654 12.745 38.855.561 14.636 3.616 34.02 21.018 43.626z",
    fill: "currentColor"
  })));
}

export default SvgGooseFootprint;